/**
 * Technical errors the customer is shown — the ones we want to see in a statistic.
 *
 * A failure is "technical" when the customer did nothing wrong and cannot fix it: the API broke,
 * a provider behind it broke, or the request never arrived. Everything the customer can act on
 * (not logged in, out of credits, invalid input) is deliberately NOT in here — see
 * TechnicalErrorReportService.classify.
 */

export const TECHNICAL_ERROR_EVENT = 'ce_tech_error';

// One GA4 event per failure class per page load per this window — a burst damper, not a count of
// what the customer saw. It cuts both ways and is meant to: a saga self-retry slower than this
// counts twice (the sagas race the retry against `Defaults.MAX_REQUEST_TIMEOUT`, 30 s), and a bulk
// loop firing the same failure every 50-150 ms counts once. `ce_tech_error` answers "is this
// happening", distinct sessions answer "how many customers". doc/faq.md, 2026-09-12.
export const GA_DEDUPE_MS = 5000;

// A saga logs the same failure a moment after its source already reported it. Within this window
// the saga report is dropped as a duplicate of the richer source report.
export const SAGA_SUPPRESS_MS = 2000;

// Per page load. Rollbar only has to prove a failure class exists; GA4 does the counting.
export const ROLLBAR_SESSION_BUDGET = 2;

// Decided once per session, not per report — so one session either reports or stays silent, and
// the sample cannot split a single incident into half-reported sessions. doc/faq.md, 2026-09-11.
export const ROLLBAR_SESSION_SAMPLE_RATE = 0.1;
export const TechnicalErrorReasons = {
  DEPENDENCY: 'dependency',
  NETWORK: 'network',
  PARSE: 'parse',
  RATE_LIMIT: 'rate_limit',
  SERVER_ERROR: 'server_error',
  TIMEOUT: 'timeout'
};
export const TechnicalErrorChannels = {
  API: 'api',
  SAGA: 'saga'
};